import { z } from "zod";
import { UpdateGroupForm } from "./update.schema";

export const createGroupSchema = z
  .object({
    name: z.string().min(1, "Le nom du groupe ne peut pas être vide"),
    type: z.enum(["visitor", "exhibitor"]),
    visitorIds: z.array(z.object({ id: z.string() })).optional(),
    exhibitorIds: z.array(z.object({ id: z.string() })).optional(),
  })
  .refine(
    (data) => {
      if (data.type === "visitor") {
        return data.visitorIds && data.visitorIds.length > 1;
      }
      if (data.type === "exhibitor") {
        return data.exhibitorIds && data.exhibitorIds.length > 1;
      }
      return false;
    },
    (data) => ({
      message:
        data.type === "visitor"
          ? "Au moins deux visiteurs doivent être sélectionnés"
          : "Au moins deux exposants doivent être sélectionnés",
      path: data.type === "visitor" ? ["visitorIds"] : ["exhibitorIds"],
    })
  );

export const createGroupDefaultValues: CreateGroupForm = {
  name: "",
  type: "visitor",
  visitorIds: [],
  exhibitorIds: [],
};

export type CreateGroupForm = z.infer<typeof createGroupSchema>;

export type GroupForm = CreateGroupForm | UpdateGroupForm;

export type GroupPayload = {
  name: string;
  type: "visitor" | "exhibitor";
  visitorIds?: string[];
  exhibitorIds?: string[];
};
